import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import AuthGuard from './auth/authGuard';
import { ReportContextProvider } from './views/ReportsFilter/ReportContext';
import { SettingsProvider } from './contexts/SettingsContext';
import './app.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/scss/winning-partner-admin-react.scss?v=2.0.0';
import './assets/css/demo.css';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import {BackgroundContextProvider} from "./contexts/BackgroundContext";
import AdminLayout from "./layouts/Admin";

ReactDOM.render(
  <AuthProvider>
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthGuard>
          <SettingsProvider>
            <CurrencyProvider>
              <ReportContextProvider>
                <BackgroundContextProvider>
                  <AdminLayout />
                </BackgroundContextProvider>
              </ReportContextProvider>
            </CurrencyProvider>
          </SettingsProvider>
        </AuthGuard>
      </LocalizationProvider>
    </BrowserRouter>
  </AuthProvider>,
  document.getElementById('root')
);
